/**
 * ADOBE CONFIDENTIAL
 * __________________
 * Copyright 2024 Adobe
 * All Rights Reserved.
 * __________________
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 */

import { events } from '@adobe-commerce/event-bus';
import { ProductModel } from '@/pdp/data/models/product-model';

export const getFetchedProductData = async ({
  scope,
}: { scope?: string } = {}): Promise<ProductModel | null> => {
  const payload = events.lastPayload('pdp/data', { scope });
  // if the event has already been emitted, return the last payload
  if (payload) {
    return Promise.resolve(payload);
  }

  // otherwise, wait for the next event
  return new Promise((resolve) => {
    const event = events.on(
      'pdp/data',
      (data) => {
        resolve(data);
        event?.off();
      },
      { eager: true, scope }
    );
  });
};
